import "@/utils/polyfills/requestIdleCallback";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import PipContainer from "./components/PipContainer/PipContainer";
import "./global.css";
import { browserRouter, memoryRouter } from "./router";
import { initApp } from "./services/bootstrap";
import getQueryClient from "./services/getQueryClient";

(async () => {
  await initApp();

  const queryClient = getQueryClient();

  const App = () => {
    const isWebview = Boolean(window.__WEBVIEW_CONFIG__);
    const router = isWebview ? memoryRouter(queryClient) : browserRouter(queryClient);

    return (
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <PipContainer />
          <RouterProvider router={router} />
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" position="bottom" />
        </QueryClientProvider>
      </StrictMode>
    );
  };

  const root = createRoot(document.getElementById("root")!);
  root.render(<App />);
})();
